import BlogPost from 'scenes/Blog/components/BlogPost'
import withPreloadedQuery from 'withPreloadedQuery'
import { BlogPostQuery } from 'scenes/Blog/components/BlogPost/BlogPost'
import { handleNotFound, serverSidePostQueryAuth } from 'services/auth'
import { isAllowed } from 'scenes/Blog/components/BlogSubcategory/BlogSubcategory'
import { BlogPost_Query, BlogPost_Query$data } from '__generated__/BlogPost_Query.graphql'

export default withPreloadedQuery(BlogPost, BlogPostQuery, {
  async serverSidePostQuery(queryResultRaw, ctx) {
    const queryResult = queryResultRaw as { data: BlogPost_Query$data} | undefined
    const redirect = await serverSidePostQueryAuth<BlogPost_Query>(
      () => isAllowed(),
    )(queryResult, ctx)

    if (!redirect) {
      handleNotFound(Boolean(queryResult?.data?.blogPost), ctx)
    }
  },
  variablesFromContext(ctx) {
    return {
      userSlug: ctx.query.user,
      slug: ctx.query.post,
    }
  },
})
